import type { UpdateConsequenceMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { UpdateConsequenceDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

import type { UpdateConsequenceInput } from './types';

export const useUpdateConsequence = createMutationHook({
  name: 'updateConsequence',
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.consequence.update.mutationOptions({ onSuccess }),
  mapInput: (variables: UpdateConsequenceInput): UpdateConsequenceInput => ({
    Id: variables.Id ?? '',
    ParentIssueId: variables.ParentIssueId ?? '',
    Title: variables.Title ?? '',
    Description: variables.Description,
    Criticality: variables.Criticality,
    CostType: variables.CostType,
    CostValue: variables.CostValue ?? 0,
    Type: variables.Type,
    CustomAttributeData: variables.CustomAttributeData ?? null,
    OriginalTimestamp: variables.OriginalTimestamp ?? '',
  }),
  invalidate: (trpc) => [
    trpc.frontend.consequence.register.queryKey(),
    trpc.frontend.consequence.consequenceById.queryKey(),
    trpc.frontend.consequence.getByParentIssueId.queryKey(),
  ],
  mapResponse: (): UpdateConsequenceMutation => ({
    update_consequence: {
      __typename: 'consequence_mutation_response',
      affected_rows: 1,
    },
  }),
  graphqlDocument: UpdateConsequenceDocument,
  graphqlVariables: (variables: UpdateConsequenceInput) => ({
    ...variables,
  }),
  validateGraphqlResponse: (data) => {
    if (data.update_consequence?.affected_rows !== 1) {
      throw new Error(
        'Records not updated. Record may have been updated by another user'
      );
    }
  },
  evictFields: ['consequence', 'consequence_aggregate'],
});
